import { render, staticRenderFns } from "./ProfileBasicView.vue?vue&type=template&id=b8e050ce&scoped=true"
import script from "./ProfileBasicView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileBasicView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileBasicView.vue?vue&type=style&index=0&id=b8e050ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e050ce",
  null
  
)

export default component.exports